(function() {
  const personaliseAccordion = document.getElementById('personaliseAccordion');
  const toggleFormBtn = document.getElementById('personaliseFormEnable');

  // Toggles open the personalisation form
  if (toggleFormBtn && personaliseAccordion) {
    toggleFormBtn.addEventListener('click', (e) => {
      e.preventDefault();
      if (personaliseAccordion.classList.contains('hidden')) {
        toggleFormBtn.setAttribute('open', '');
        personaliseAccordion.classList.remove('hidden');
        personaliseAccordion.removeAttribute('aria-hidden');
      } else {
        toggleFormBtn.removeAttribute('open');
        personaliseAccordion.classList.add('hidden');
        personaliseAccordion.setAttribute('aria-hidden', true);
      }
    })
  }
    
  const fontDropdowns = document.querySelectorAll('[data-personalise-font]');

  // Font dropdowns
  if (fontDropdowns) {
    fontDropdowns.forEach(select => {
      select.addEventListener('change', (e) => {
        const imageAsset = e.target.selectedOptions[0].dataset.fileName;
        if (imageAsset) {
          e.target.setAttribute('data-font-bg', imageAsset);
        }
      })
    });
  }

  // Toggles open accordions
  const accordions = document.querySelectorAll('[data-personalise-accordion]');

  if (accordions) {
    accordions.forEach(accordion => {
      const toggle = accordion.querySelector('.personalise-form__options--checkbox');
      toggle.addEventListener('change', (e) => {
        const body = accordion.querySelector('[data-personalise-body]');
  
        if (toggle.checked) {
          body.classList.remove('hidden');
          body.removeAttribute('disabled');
          body.setAttribute('aria-hidden', false);
        } else {
          body.classList.add('hidden');
          body.disabled = true;
          body.setAttribute('aria-hidden', true);
        }
      });
    });
  };
  
  const tabLinks = document.querySelectorAll('[data-form-toggle]');
  
  // Toggles open tab content
  if (tabLinks) {
    tabLinks.forEach(link => {  
      link.addEventListener('click', (e) => {

        let linkContainer = "";
        
        if (link.closest('[data-personalise-container]')) {
          linkContainer = link.closest('[data-personalise-container]');
        } else if (link.closest('[data-personalise-accordion]')) {
          linkContainer = link.closest('[data-personalise-accordion]');
        } else {
          linkContainer = link.closest('#personaliseForm');
        }
        
        const tabsContent = linkContainer.querySelectorAll('[data-form-tab]');

        if (!tabsContent) return

        tabsContent.forEach(tab => {
          tab.classList.add('hidden');
          tab.setAttribute('aria-hidden', true);
          if (tab.nodeName === "FIELDSET") tab.disabled = true;
        })

        const target = linkContainer.querySelector(`[data-form-tab="${link.getAttribute('data-form-toggle')}"]`);

        if (!target || link.getAttribute('data-form-toggle').toUpperCase === "NONE") return;

        if (target.classList.contains('hidden')) {
          target.classList.remove('hidden');
          target.removeAttribute('aria-hidden');
          if (target.nodeName === "FIELDSET") target.disabled = false;
        }
      })
    });
  }
}());